import DefaultLayout from '@/Layouts/DefaultLayout';
import { lazy } from 'react';
import { LoginRoutes } from '@/features/auth/routes/routes';
import { AuthInitializer } from '@/features/auth/guard/authInitializer';
import { HumanResourcesRoutes } from '@/features/humanResources/routes/routes';
import { SelfServicesRoutes } from '@/features/selfServices/routes/routes';
import { HrSelfServicesRoutes } from '@/features/hrSelfServices/routes/routes';
import { CareerPathRoutes } from '@/features/careerPath/routes/routes';
import { BranchesRoutes } from '@/features/branch/routes/routes';
import { TraineesRoutes } from '@/features/trainees/routes/routes';
import { DeductionsRoutes } from '@/features/deductions/routes/routes';
import { PayrollRoutes } from '@/features/payroll/routes/routes';
import { TasksRoutes } from '@/features/tasks/routes/routes';
import { InsuranceRoutes } from '@/features/Insurance/routes/routes';
import { NotificationsRoutes } from '@/features/notifications/routes/routes';
import { AccessControlRoutes } from '@/features/accessControl/routes/routes';
import { SubscriptionsRoutes } from '@/features/subscriptions/routes/routes';
import { EntryExitRoutes } from '@/features/entry-and-exit/routes/routes';

// ----------------------------------------------------------------------

const Home = lazy(() => import('@/core/global-pages/Home'));
const SoonPage = lazy(() => import('@/core/global-pages/SoonPage'));
const SettingsPage = lazy(() => import('@/features/settings/pages/Settings.page'));

// ----------------------------------------------------------------------

const routes = [
    {
        path: '/',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        children: [
            { index: true, element: <Home /> },
            {
                path: '/coming-soon',
                element: <SoonPage />,
                layout: 'default',
                isAuthReq: true,
            },
            { path: '/settings', element: <SettingsPage /> },

            ...HumanResourcesRoutes,
            ...SelfServicesRoutes,
            ...CareerPathRoutes,
            ...HrSelfServicesRoutes,
            ...BranchesRoutes,
            ...TraineesRoutes,
            ...DeductionsRoutes,
            ...PayrollRoutes,
            ...TasksRoutes,
            ...InsuranceRoutes,
            ...NotificationsRoutes,
            ...AccessControlRoutes,
            ...SubscriptionsRoutes,
            ...EntryExitRoutes,
        ],
    },
    ...LoginRoutes,
];
export { routes };
